// deps
import React, { memo } from "react";

// types
import { IBillElement } from "@dineout-payment-success-ui/interfaces";

// styles
import {
    BillDetailsItemWrapper,
    LogoTextWrapper,
    RightTextWrapper,
    StrikedText,
    LeftSubTextWrapper,
    StyledText,
    ImageWrapper,
} from "./styles";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// internal-deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// helpers
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

// test-ids
import { PAYMENT_SUCCESS_BILL_DETAILS } from "@swiggy-private/payment-test-ids";
import { BILL_ELEMENT_ENTRIES } from "@dineout-payment-success-ui/constants/Constants";
import { useTheme } from "styled-components";

const BillDetailsItem: React.FC<IBillElement> = ({
    leftText,
    leftTextStyle,
    rightText,
    rightTextStyle,
    offerUrl,
    offerLogoStyle,
    isClickable = false,
    id,
    strikethroughAmount,
    leftSubText,
    leftSubTextStyles,
    toolTipClicked,
}) => {
    const theme = useTheme();

    const dottedStyle =
        id === BILL_ELEMENT_ENTRIES.CONVENIENCE_FEE_TYPE
            ? {
                  borderBottom: `1px dashed ${theme.colors[theme.colorMode].border_Primary}`,
                  cursor: isClickable ? "pointer" : "default",
              }
            : {};
    return (
        <BillDetailsItemWrapper>
            <LeftSubTextWrapper>
                <LogoTextWrapper>
                    {offerUrl ? (
                        <ImageWrapper width={`${offerLogoStyle?.width || 0}`} height={`${offerLogoStyle?.height || 0}`}>
                            <Image
                                src={getCloudinaryUrl(offerUrl, { width: offerLogoStyle?.width })}
                                style={offerLogoStyle}
                            />
                        </ImageWrapper>
                    ) : null}
                    <StyledText
                        variant={leftTextStyle?.variant ? leftTextStyle?.variant : "V2.body2.neutral.medium"}
                        color={leftTextStyle?.color ? leftTextStyle?.color : "text_Med_Emphasis"}
                        data-testid={PAYMENT_SUCCESS_BILL_DETAILS.BILL_DETAIL_ITEM.LEFT_TEXT}
                        style={dottedStyle}
                        onClick={isClickable ? toolTipClicked : undefined}
                    >
                        <span dangerouslySetInnerHTML={{ __html: leftText || "" }} />
                    </StyledText>
                </LogoTextWrapper>
                {leftSubText && (
                    <Text
                        variant={
                            leftSubTextStyles?.variant ? leftSubTextStyles?.variant : "V2.overline.neutral.regular"
                        }
                        color={leftSubTextStyles?.color ? leftSubTextStyles?.color : "text_Med_Emphasis"}
                    >
                        {leftSubText}
                    </Text>
                )}
            </LeftSubTextWrapper>
            <RightTextWrapper>
                {strikethroughAmount && (
                    <StrikedText
                        variant={rightTextStyle?.variant ? rightTextStyle?.variant : "V2.body2.neutral.bold"}
                        color="text_Low_Emphasis"
                        data-testid={PAYMENT_SUCCESS_BILL_DETAILS.BILL_DETAIL_ITEM.STRIKED_TEXT}
                    >
                        {strikethroughAmount}
                    </StrikedText>
                )}
                {rightText && (
                    <Text
                        variant={rightTextStyle?.variant ? rightTextStyle?.variant : "V2.body2.neutral.bold"}
                        color={rightTextStyle?.color ? rightTextStyle?.color : "text_High_Emphasis"}
                        data-testid={id}
                    >
                        {rightText}
                    </Text>
                )}
            </RightTextWrapper>
        </BillDetailsItemWrapper>
    );
};

export default memo(BillDetailsItem);
